import { Component } from '@theme/component';

class TBHNPPairPurchase extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.isSet = this.dataset.mode === 'set';
    this.rootProduct = this.closest('tbhnp-mobile-product-slide');
    this.variants = JSON.parse(this.querySelector('[data-pair-variants]').textContent);
    this.words = JSON.parse(this.querySelector('[data-pair-text]').textContent);
    this.button = this.querySelector('[data-pair-add]');
    this.status = this.querySelector('[data-pair-status]');
    this.image = this.querySelector('.tbhnp-pair__image img');
    this.options = [...(this.variants.find(v => v.available) || this.variants[0]).options];
    for (const select of this.querySelectorAll('[data-pair-option-select]')) this.options[Number(select.dataset.pairOptionSelect)] = '';
    this.dismissKey = `tbhnp-pair-dismissed:${this.dataset.dismissKey || this.dataset.sourceId}`;
    if (!this.isSet) { try { this.hidden = sessionStorage.getItem(this.dismissKey) === '1'; } catch {} }
    this.addEventListener('click', event => {
      const dismiss = event.target.closest('[data-pair-dismiss]');
      if (dismiss) {
        this.hidden = true;
        try { sessionStorage.setItem(this.dismissKey, '1'); } catch {}
        this.closest('dialog')?.querySelector('button')?.focus();
        return;
      }
      const swatch = event.target.closest('[data-pair-color]');
      if (swatch && !this.busy) {
        this.options[Number(swatch.dataset.optionIndex)] = swatch.dataset.pairColor;
        this.added = false;
        this.refresh();
      }
      if (event.target.closest('[data-pair-add]')) this.add();
    }, { signal });
    this.addEventListener('change', event => {
      if (!event.target.matches('[data-pair-option-select]') || this.busy) return;
      this.options[Number(event.target.dataset.pairOptionSelect)] = event.target.value;
      this.added = false;
      this.refresh();
    }, { signal });
    this.rootProduct?.addEventListener('tbhnp:selection-change', () => { this.added = false; this.refresh(); }, { signal });
    this.refresh();
  }
  disconnectedCallback() { this.controller?.abort(); super.disconnectedCallback(); }
  money(value) {
    return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(value / 100);
  }
  refresh() {
    if (this.busy) return;
    for (const swatch of this.querySelectorAll('[data-pair-color]')) {
      const selected = this.options[Number(swatch.dataset.optionIndex)] === swatch.dataset.pairColor;
      swatch.setAttribute('aria-pressed', String(selected));
      if (selected) swatch.closest('fieldset').querySelector('[data-pair-color-label]').textContent = swatch.dataset.pairColor;
    }
    for (const select of this.querySelectorAll('[data-pair-option-select]')) {
      const index = Number(select.dataset.pairOptionSelect);
      for (const option of select.options) {
        if (!option.value) continue;
        const available = this.variants.some(v => v.available && v.options.every((value, i) => i === index ? value === option.value : !this.options[i] || value === this.options[i]));
        option.disabled = !available;
        option.textContent = option.value + (available ? '' : ` · ${this.words.soldOut}`);
      }
      const selected = [...select.options].find(o => o.value === this.options[index]);
      if (selected?.disabled) this.options[index] = '';
      select.value = this.options[index];
    }
    this.variant = this.variants.find(v => v.options.every((value, i) => value === this.options[i]));
    const imageVariant = this.variant || this.variants.find(v => v.options.every((value, i) => !this.options[i] || value === this.options[i]));
    const image = imageVariant?.featured_image;
    if (image?.src && this.image) {
      const url = new URL(image.src, location.origin); url.searchParams.set('width', '240');
      this.image.src = url.href; this.image.removeAttribute('srcset');
    }
    const price = (this.variant || imageVariant)?.price;
    this.querySelector('[data-pair-price]').textContent = price === undefined ? '—' : this.money(price);
    const main = this.rootProduct?.variant;
    const total = price === undefined || (this.isSet && !main) ? null : price + (this.isSet ? main.price : 0);
    this.querySelector('[data-pair-button-price]').textContent = total === null ? '—' : this.money(total);
    this.button.disabled = this.added || !this.variant?.available || (this.isSet && !main?.available);
    this.status.textContent = this.added ? this.words.added : this.options.some(v => !v) ? this.words.choose : this.button.disabled ? this.words.unavailable : this.variant.title;
  }
  async add() {
    if (this.busy || this.button.disabled || this.rootProduct?.busy) return;
    const main = this.rootProduct?.variant;
    if (!this.variant?.available || (this.isSet && !main?.available)) return;
    this.busy = true;
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.status.textContent = this.words.adding;
    const lockedRoot = this.isSet ? this.rootProduct : null;
    if (lockedRoot) { lockedRoot.busy = true; lockedRoot.addButton.disabled = true; }
    const items = [{ id: this.variant.id, quantity: 1 }];
    if (this.isSet) items.unshift({ id: main.id, quantity: 1 });
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(c => c.dataset.sectionId).filter(Boolean))].slice(0, 5);
    const routes = window.Shopify?.routes?.root || '/';
    let wasAdded = false;
    try {
      const response = await fetch(`${routes}cart/add.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, sections: sectionIds, sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || this.words.error);
      wasAdded = true;
      this.added = true;
      const cartResponse = await fetch(`${routes}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(this.words.refreshError);
      const cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'tbhnp-pair-purchase', data: { source: 'tbhnp-pair-purchase', itemCount: cart.item_count, sections: result.sections || {} } } }));
      document.querySelector('cart-drawer-component')?.open();
      this.status.textContent = this.words.added;
    } catch (error) {
      this.status.textContent = wasAdded ? this.words.refreshError : (error.message || this.words.error);
      if (wasAdded) document.querySelector('cart-drawer-component')?.open();
    } finally {
      this.busy = false;
      this.button.removeAttribute('aria-busy');
      if (lockedRoot) { lockedRoot.busy = false; lockedRoot.syncAddButton(); }
      this.button.disabled = wasAdded || !this.variant?.available || (this.isSet && !this.rootProduct?.variant?.available);
    }
  }
}
if (!customElements.get('tbhnp-pair-purchase')) customElements.define('tbhnp-pair-purchase', TBHNPPairPurchase);

